import React from 'react';
import { Button, Space, Typography } from 'antd';
import { WifiOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { usePwa } from '../../hooks/usePwa';

const { Text } = Typography;

const PwaBanner: React.FC = () => {
  const { t } = useTranslation();
  const { needRefresh, updateSW, isOffline } = usePwa();

  if (!needRefresh && !isOffline) {
    return null;
  }

  const isUpdate = needRefresh;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        background: isUpdate ? '#111827' : '#1f2937',
        color: '#fff',
        borderRadius: 8,
        padding: '12px 20px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        maxWidth: 'calc(100% - 48px)',
      }}
    >
      {isUpdate ? (
        <Space>
          <CloudDownloadOutlined style={{ fontSize: 18 }} />
          <Text style={{ color: '#fff' }}>{t('pwa.updateAvailable', 'Një version i ri është i disponueshëm')}</Text>
          <Button
            size="small"
            type="primary"
            onClick={() => updateSW(true)}
            style={{ marginLeft: 8 }}
          >
            {t('pwa.reload', 'Rifresko')}
          </Button>
        </Space>
      ) : (
        <Space>
          <WifiOutlined style={{ fontSize: 18 }} />
          <Text style={{ color: '#fff' }}>
            {t('pwa.offline', 'Jeni offline — të dhënat shfaqen nga cache-ja. Disa veprime kërkojnë internet.')}
          </Text>
        </Space>
      )}
    </div>
  );
};

export default PwaBanner;
